export default {
      id: "fund-single-box-usage",
      viewBox: "0 0 34 28",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#fund-single-box",
      toString: function () {
        return this.url;
      }
    }